// Parse timeout from env, defaulting to 30 seconds
const parseEnvTimeout = (envValue: string | undefined, defaultMs: number): number => {
  if (!envValue) return defaultMs;
  const parsed = parseInt(envValue, 10);
  return isNaN(parsed) || parsed <= 0 ? defaultMs : parsed;
};

export const AGENT_CONFIG = {
  MAX_TURNS: 6,
  /** Default timeout for model calls. Can be overridden via MORPH_WARP_GREP_TIMEOUT env var (in ms) */
  TIMEOUT_MS: parseEnvTimeout(process.env.MORPH_WARP_GREP_TIMEOUT, 60_000),
  MAX_CONTEXT_CHARS: 321_600,
  MAX_OUTPUT_LINES: 200,
  MAX_LIST_RESULTS: 500,
  MAX_READ_LINES: 800,
  MAX_LIST_DEPTH: 3,
  LIST_TIMEOUT_MS: 2_000,
};

/**
 * Comprehensive exclusion list for directories and files
 * These patterns are used with ripgrep's -g flag
 */
const BUILTIN_EXCLUDES = [
  // Version control
  '.git', '.svn', '.hg', '.bzr',
  
  // Dependencies
  'node_modules', 'bower_components', '.pnpm', '.yarn',
  'vendor', 'packages', 'Pods', '.bundle',
  
  // Python
  '__pycache__', '.pytest_cache', '.mypy_cache', '.ruff_cache',
  '.venv', 'venv', '.tox', '.nox', '.eggs', '*.egg-info',
  
  // Build outputs
  'dist', 'build', 'out', 'output', 'target', '_build',
  '.next', '.nuxt', '.output', '.vercel', '.netlify',
  
  // Cache directories
  '.cache', '.parcel-cache', '.turbo', '.nx', '.gradle',
  
  // IDE/Editor
  '.idea', '.vscode', '.vs',
  
  // Coverage
  'coverage', '.coverage', 'htmlcov', '.nyc_output',
  
  // Temporary
  'tmp', 'temp', '.tmp', '.temp',
  
  // Lock files
  'package-lock.json', 'yarn.lock', 'pnpm-lock.yaml', 'bun.lockb',
  'Cargo.lock', 'Gemfile.lock', 'poetry.lock',
  
  // Binary/minified
  '*.min.js', '*.min.css', '*.bundle.js',
  '*.wasm', '*.so', '*.dll', '*.pyc',
  '*.map', '*.js.map',
  
  // Hidden directories catch-all
  '.*',
];

export const DEFAULT_EXCLUDES = (process.env.MORPH_WARP_GREP_EXCLUDE || '')
  .split(',')
  .map(s => s.trim())
  .filter(Boolean)
  .concat(BUILTIN_EXCLUDES);

export const DEFAULT_MODEL = 'morph-warp-grep-v2.1';
